import { render, staticRenderFns } from "./InvitePage.vue?vue&type=template&id=a1283688&scoped=true&"
import script from "./InvitePage.vue?vue&type=script&lang=ts&"
export * from "./InvitePage.vue?vue&type=script&lang=ts&"
import style0 from "./InvitePage.vue?vue&type=style&index=0&id=a1283688&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1283688",
  null
  
)

export default component.exports